export const PERMANENT_SEARCH_PARAMS = ['debug', 'preview', 'slug', 'stepName'] as const
